<template>
    <div class="program-info-skeleton">
        <div class="program-info-skeleton__wrap-img">
            <common-icon :icon-name="'IconNoPicture'" />
        </div>
        <div class="program-info-skeleton__info">
            <div class="program-info-skeleton__title" />
            <div class="program-info-skeleton__short-info" />
            <div class="program-info-skeleton__description" />
        </div>
    </div>
</template>